

import React, { useState } from 'react';
import Slider from 'rc-slider';
// import 'rc-slider/assets/index.css';
import css from './FieldSliderInput.module.css';


function FieldSliderInput({ onChange, sliderValue ,disabled}) {
  const [value, setValue] = useState(sliderValue ? sliderValue : 1);

  const handleSliderChange = (newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  // function log(value) {
  //   console.log(value); //eslint-disable-line
  // }


  const marks = {
    1: 'low priority',
    2: 'neutral',
    3: 'high priority'
  };

  return (
    <div className={css.sliderWrapper}>
      <Slider
        min={1}
        max={3}
        step={null}
        marks={marks}
        disabled={disabled?disabled:false}
        value={value}
        onChange={handleSliderChange}
        railStyle={{ backgroundColor: '#ebedf1', borderColor: "#d0d6e0", top: 0 }}
        trackStyle={{ backgroundColor: '#f58b65', top: '0' }}
        activeDotStyle={{
          borderColor: '#E8EEF9',
          borderWidth: '4px',
          backgroundColor: '#f58b65',
          width: '16px',
          height: '16px',
        }}
        dotStyle={{
          backgroundColor: '#E8EEF9',
          borderColor: '#E8EEF9',
          // borderWidth: '4px',
          width: '16px',
          height: '16px',
          // top: '-4px',
        }}
        handleStyle={{
          borderColor: '#E8EEF9',
          borderWidth: '4px',
          backgroundColor: '#f58b65',
          width: '16px',
          height: '16px',
          top: '0'
        }}
      />
    </div>
  );
}

export default FieldSliderInput;
